import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["type", "choices"]

  connect() {
    this.toggleChoices()
  }

  toggleChoices() {
    this.choicesTarget.classList.toggle("hidden", !["select", "radio"].includes(this.typeTarget.value))
  }
}
